import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-get-accessories',
    templateUrl: './get-accessories.component.html',
    styleUrls: ['./get-accessories.component.scss'],
})
export class GetAccessoriesComponent {

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<GetAccessoriesComponent>
    ) {
        console.log(data);
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }
}
